import { getFromStorage } from 'utils/localStorage';
export var playSound = function (sound) {
    var isSoundEnabled = getFromStorage('isSoundEnabled')();
    if (isSoundEnabled)
        sound();
};
export default playSound;
